var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "15 15 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1 svg-fill-color",
    d: "M25 15c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 1.4a8.6 8.6 0 1 0 0 17.2 8.6 8.6 0 0 0 0-17.2zm-3.787 3.75.085.073 3.521 3.52 3.52-3.52a.76.76 0 0 1 1.076 1.075l-3.52 3.521 3.52 3.52a.76.76 0 0 1 .074.99l-.074.086a.76.76 0 0 1-.99.074l-.086-.074-3.52-3.52-3.52 3.52a.76.76 0 0 1-1.076-1.076l3.52-3.52-3.52-3.52a.76.76 0 0 1-.074-.99l.074-.086a.76.76 0 0 1 .99-.074z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.e9075c7fefa952e0f22551fc28789643.svg";
export { ForwardRef as ReactComponent };